import { Link } from 'react-router-dom'
import clsx from 'clsx'

export function NavLink({
  href,
  ...props
}: React.ComponentPropsWithoutRef<typeof Link> & { href?: string }) {
  return (
    <Link
      {...props}
      to={href || props.to || '#'}
      className={clsx(
        'text-sm font-normal leading-6 text-slate-900',
        props.className
      )}
    />
  )
} 